import { validateGeolocation } from 'js/hooks/auth/pas';
import { MutableRefObject, useCallback } from 'react';
import { publicEventsAPIService } from 'js/services/publicEventsAPI.service';

import * as constants from '../constants';
import * as Types from '../types';

export const useTriggerGeolocation = ({
    setTransactionID,
    setNextTime,
    setShowOverlay,
    cancelRef,
    geolocationType,
    reasonRef,
    triggerTimestampRef
}: {
    setTransactionID: (transactionID: string | null) => void;
    setNextTime: (nextTime: number) => void;
    setShowOverlay: (showOverlay: boolean) => void;
    cancelRef: MutableRefObject<any>;
    reasonRef: MutableRefObject<constants.GEOLOCATION_REASON>;
    triggerTimestampRef: MutableRefObject<number | null>;
    geolocationType: string;
}) => {
    return useCallback(async ({
        latitude = null,
        longitude = null,
        reason = null
    }: Types.ITriggerGeolocationOptions = {}) => {
        if (cancelRef.current) {
            return;
        }

        // set the reason for Geolocation
        reasonRef.current = reason ?? constants.GEOLOCATION_REASON.UNDEFINED;

        publicEventsAPIService.trigger('geofencing-trigger', { reason: reasonRef.current });

        triggerTimestampRef.current = null;
        setTransactionID(null);
        setNextTime(0);

        const response = await validateGeolocation(latitude, longitude, null, null, null, geolocationType);
        const sessionValidationData = response.data.sessionValidationData || {};

        if (!sessionValidationData.SessionValidationByGeolocationData) {
            // no geofencing -- go straight to end.
            return;
        }

        const sessionValidationByGeolocationData = sessionValidationData.SessionValidationByGeolocationData || [];
        const geolocationData = sessionValidationByGeolocationData[0] || {};
        const nextCheckIn = Number(geolocationData.nextCheckIn);

        if (nextCheckIn > 0) {
            // check will be done in some time, all good for now
            setShowOverlay(false);
        } else {
            setShowOverlay(true);
        }

        // ensure that nextTime is set before setting txId
        setNextTime(nextCheckIn);
        triggerTimestampRef.current = Date.now();
        setTransactionID(geolocationData.transactionId);
    }, [
        triggerTimestampRef,
        setShowOverlay,
        setTransactionID,
        setNextTime,
        cancelRef,
        geolocationType,
        reasonRef
    ]);
};
